module.exports = __webpack_public_path__ + "img/logo.png_color.86bf861a.png";